import { render, staticRenderFns } from "./CustomAudio.vue?vue&type=template&id=83231b6a&scoped=true&"
import script from "./CustomAudio.vue?vue&type=script&lang=js&"
export * from "./CustomAudio.vue?vue&type=script&lang=js&"
import style0 from "./CustomAudio.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomAudio.vue?vue&type=style&index=1&id=83231b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83231b6a",
  null
  
)

export default component.exports